"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Radio_component_exports = {};
__export(Radio_component_exports, {
  Radio: () => Radio,
  RadioGroup: () => RadioGroup
});
module.exports = __toCommonJS(Radio_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_radio = require("@react-aria/radio");
var import_react_stately = require("react-stately");
var import_focus = require("@react-aria/focus");
var import_visually_hidden = require("@react-aria/visually-hidden");
var import_utils = require("@react-aria/utils");
var import_clsx = __toESM(require("clsx"));
var import_HelperText = __toESM(require("../HelperText/HelperText.component"));
var import_Label = require("../Label/Label.component");
let RadioContext = (0, import_react.createContext)(null);
const Circle = ({ isSelected, isFocusVisible, isFocused, isDisabled, size }) => {
  const [isPressed, setIsPressed] = (0, import_react.useState)(false);
  const [isPressedAndFocused, setIsPressedAndFocused] = (0, import_react.useState)(false);
  const [isHover, setIsHover] = (0, import_react.useState)(false);
  const sizes = {
    small: { external: 8, intermediate: 7, internal: 6, focus: 9.4, strokeWidth: 1 },
    medium: { external: 10, intermediate: 9, internal: 7, focus: 12.4, strokeWidth: 1 }
  };
  const circleSize = sizes[size] || sizes.medium;
  const handleMouseDown = () => {
    setIsPressed(true);
    if (isFocused) setIsPressedAndFocused(true);
  };
  const handleMouseUpLeave = () => {
    setIsPressed(false);
    setIsPressedAndFocused(false);
    setIsHover(false);
  };
  const handleMouseOver = () => {
    if (!isDisabled) setIsHover(true);
  };
  const getSvgStyle = (size2) => {
    return `h-l w-l gmui-radio-svg ${size2 === "medium" ? "ml-2" : ""}`;
  };
  const svgStyle = getSvgStyle(size);
  const internalCircleStyle = (0, import_react.useMemo)(() => {
    return (0, import_clsx.default)("h-m w-m gmui-radio-internal", {
      "gmui-radio-internal-hover-selected": isHover && isSelected,
      "gmui-radio-internal-selected": isSelected && !isPressed,
      "gmui-radio-internal-pressed-selected": isSelected && isPressed,
      "gmui-radio-internal-pressed-not-selected": !isSelected && isPressed,
      "gmui-radio-internal-disabled-selected": isDisabled && isSelected,
      "gmui-radio-internal-disabled-not-selected": isDisabled && !isSelected
    });
  }, [isHover, isSelected, isPressed, isDisabled]);
  const intermediateCircleStyle = (0, import_react.useMemo)(() => {
    return (0, import_clsx.default)("gmui-radio-intermediate", {
      "gmui-radio-intermediate-hover-selected": isHover && isSelected,
      "gmui-radio-intermediate-hover-not-selected": isHover && !isSelected,
      "gmui-radio-intermediate-pressed-not-selected": !isSelected && isPressed,
      "gmui-radio-intermediate-disabled": isDisabled
    });
  }, [isHover, isSelected, isPressed, isDisabled]);
  const externalCircleStyle = (0, import_react.useMemo)(() => {
    return (0, import_clsx.default)("gmui-radio-external", {
      "gmui-radio-external-hover-selected": isHover && isSelected,
      "gmui-radio-external-hover": isHover && !isSelected,
      "gmui-radio-external-pressed-selected": isPressed && isSelected,
      "gmui-radio-external-pressed-not-selected": isPressed && !isSelected,
      "gmui-radio-external-selected": isSelected && !isPressed,
      "gmui-radio-external-disabled": isDisabled
    });
  }, [isHover, isSelected, isPressed, isDisabled]);
  const showFocusCircle = isFocusVisible || isPressedAndFocused;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
    "svg",
    {
      className: svgStyle,
      "aria-hidden": "true",
      onMouseDown: handleMouseDown,
      onMouseUp: handleMouseUpLeave,
      onMouseLeave: handleMouseUpLeave,
      onMouseOver: handleMouseOver,
      viewBox: `0 0 ${circleSize.external * 2 + 6} ${circleSize.external * 2 + 6}`,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "circle",
          {
            cx: "50%",
            cy: "50%",
            r: circleSize.external,
            className: externalCircleStyle,
            strokeWidth: circleSize.strokeWidth
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "circle",
          {
            cx: "50%",
            cy: "50%",
            r: circleSize.intermediate,
            className: intermediateCircleStyle
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("circle", { cx: "50%", cy: "50%", r: circleSize.internal, className: internalCircleStyle }),
        showFocusCircle && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("circle", { cx: "50%", cy: "50%", r: circleSize.focus, className: "gmui-radio-focus" })
      ]
    }
  );
};
const RadioGroup = (props) => {
  const {
    children,
    label,
    description,
    errorMessage,
    size = "small",
    radioGroupLabelStyles
  } = props;
  const { orientation = "horizontal" } = props;
  const descriptionId = (0, import_utils.useId)();
  let state = (0, import_react_stately.useRadioGroupState)(props);
  let { radioGroupProps, labelProps, descriptionProps, errorMessageProps } = (0, import_radio.useRadioGroup)(
    props,
    state
  );
  radioGroupProps["aria-describedby"] = description ? descriptionId : void 0;
  const radioGroupStyle = (0, import_clsx.default)([
    "flex w-max",
    `${orientation === "horizontal" ? "flex-row" : "flex-col"}`,
    `${orientation === "vertical" && "items-start"}`
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", __spreadProps(__spreadValues({ className: radioGroupStyle }, radioGroupProps), { children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", __spreadProps(__spreadValues({}, labelProps), { className: radioGroupLabelStyles, children: label })),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RadioContext.Provider, { value: { state, size, orientation }, children })
    ] })),
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { children: [
      description && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_HelperText.default,
        __spreadProps(__spreadValues({
          id: descriptionId,
          helperText: description
        }, descriptionProps), {
          role: "status"
        })
      ),
      errorMessage && state.isInvalid && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_HelperText.default,
        __spreadProps(__spreadValues({
          validationError: errorMessage
        }, errorMessageProps), {
          role: "alert"
        })
      )
    ] })
  ] });
};
const Radio = (props) => {
  let { children, className = "justify-center items-center" } = props;
  let { state, size, orientation } = (0, import_react.useContext)(RadioContext);
  let ref = (0, import_react.useRef)(null);
  let { inputProps, isSelected, isDisabled } = (0, import_radio.useRadio)(props, state, ref);
  let { isFocusVisible, focusProps, isFocused } = (0, import_focus.useFocusRing)();
  const radioStyle = (0, import_clsx.default)([
    "flex",
    isDisabled ? "radio-label-text-color-disabled" : "radio-label-text-color",
    size === "small" ? "font-style-body-compact gap-1" : "font-style-body gap-2",
    orientation === "vertical" ? "mb-4" : "mr-4",
    className
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_Label.Label, { className: radioStyle, children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_visually_hidden.VisuallyHidden, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("input", __spreadProps(__spreadValues(__spreadValues({}, inputProps), focusProps), { ref })) }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      Circle,
      {
        isSelected,
        isFocusVisible,
        isFocused,
        isDisabled,
        size
      }
    ),
    children
  ] });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Radio,
  RadioGroup
});
//# sourceMappingURL=Radio.component.js.map